import './InputWithPlusMinusButtons.pcss';
import React, { useState, useEffect } from 'react';
import classnames from 'classnames';

type Props = {
  initialValue: number;
  onChange: (value: number) => void;
  className?: string;
  lowerBound: number;
};

export const InputWithPlusMinusButtons = ({
  initialValue,
  onChange,
  className,
  lowerBound,
}: Props) => {
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!initialValue) {
      return;
    }
    setValue(initialValue);
  }, [initialValue]);

  const inc = () => {
    const newValue = value + 1;
    setValue(newValue);
    onChange(newValue);
  };

  const dec = () => {
    const newValue = value - 1;
    if (newValue >= lowerBound) {
      setValue(newValue);
      onChange(newValue);
    }
  };

  return (
    <div className={classnames('number-input-with-buttons', className)}>
      <button onClick={dec} />
      <input className="" min="0" name="quantity" value={value} type="number" />
      <button onClick={inc} className="plus" />
    </div>
  );
};
